import {parseInteger} from '@benchling/js-utils';

import {Filter, FilterErrors, FilterKey} from 'search/SearchConstants';

export const NUMERIC_FILTERS = [FilterKey.GRID_EMPTY_POSITIONS];

export const VALUE_MUST_BE_INTEGER_ERROR_MSG = 'Value must be an integer.';
export default function validateNumericFilters(filters: Array<Filter>): FilterErrors {
  return filters.map((filter) => {
    if (NUMERIC_FILTERS.includes(filter.key)) {
      if (filter.value && parseInteger(filter.value as string) == null) {
        return 'Value must be an integer.';
      }
    }
    return null;
  });
}
